import { useState } from "react";
import MobileHeader from "../component/MobileHeader";
import "../css/findid.css"
import FindId1 from "../findIdPw/FindId1";
import FindId2 from "../findIdPw/FindId2";

export default function MobileFindId() {
    const [step, setStep] = useState(0);

    // 🔹 FindId 결과를 보관할 부모 상태
    const [result, setResult] = useState({
        idMasked: null,
        phoneNumber: null,
    });

    return (
        <>
            <nav className="Nav_FindId">
                <MobileHeader onPrev={() => {
                    window.history.back()
                }}></MobileHeader>
                {step === 0 && (
                    <FindId1
                        onNext={(payload) => {
                            setResult(payload); // { idMasked, phoneNumber }
                            setStep(1);
                        }}        // 다음: DateStep으로 전환
                    />
                )}
                {step === 1 && (
                    <FindId2
                        idMasked={result.idMasked}
                        phoneNumber={result.phoneNumber}
                        onReset={() => setStep(0)}           // 다음: DateStep으로 전환
                    />
                )}
            </nav>
        </>
    )
}